(function () {
  var widgetSelector = '#judgeme_product_reviews.jdgm-review-widget';
  var mobileQuery = window.matchMedia('(max-width: 767px)');
  var scheduled = false;

  function getSummary(widget) {
    var averageElement = widget.querySelector('.jdgm-rev-widg__summary-average');
    var countElement = widget.querySelector('.jdgm-rev-widg__summary-text');
    var averageMatch = averageElement && averageElement.textContent.match(/\d+(?:\.\d+)?/);
    var countMatch = countElement && countElement.textContent.match(/\d+/);

    return {
      average: averageMatch ? Number(averageMatch[0]).toFixed(1) : '',
      count: countMatch ? Number(countMatch[0]) : 0
    };
  }

  function setText(element, value) {
    if (element && element.textContent !== value) {
      element.textContent = value;
    }
  }

  function setExpanded(widget, expanded) {
    var toggle = widget.querySelector('.mrjewels-reviews-toggle');
    var title = widget.querySelector('.jdgm-rev-widg__title');
    var summary = getSummary(widget);

    widget.classList.toggle('mrjewels-reviews-expanded', expanded);
    document.documentElement.classList.toggle('mrjewels-reviews-modal-open', expanded);

    if (toggle) {
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.setAttribute('aria-label', expanded ? 'Close reviews' : 'Show all reviews');
      setText(toggle, expanded ? 'Close' : 'Show all');
    }

    if (title && (expanded || mobileQuery.matches)) {
      setText(title, expanded ? 'Reviews (' + summary.count + ')' : 'Ratings & Reviews');
    }

    if (expanded) {
      widget.setAttribute('role', 'dialog');
      widget.setAttribute('aria-modal', 'true');
      widget.setAttribute('aria-label', 'Customer reviews');
      widget.scrollTop = 0;
    } else {
      widget.removeAttribute('role');
      widget.removeAttribute('aria-modal');
      widget.removeAttribute('aria-label');
    }
  }

  function setRatingModal(widget, expanded) {
    var toggle = widget.querySelector('.mrjewels-reviews-toggle');
    var title = widget.querySelector('.jdgm-rev-widg__title');
    var writeReviewLink = widget.querySelector('.jdgm-write-rev-link');

    if (expanded) {
      setExpanded(widget, false);
      if (writeReviewLink) {
        writeReviewLink.click();
      }
    } else if (widget.classList.contains('mrjewels-rating-modal') && writeReviewLink) {
      writeReviewLink.click();
    }

    widget.classList.toggle('mrjewels-rating-modal', expanded);
    document.documentElement.classList.toggle('mrjewels-reviews-modal-open', expanded);

    if (toggle) {
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.setAttribute('aria-label', expanded ? 'Close rating form' : 'Show all reviews');
      setText(toggle, expanded ? 'Close' : 'Show all');
    }

    if (title && (expanded || mobileQuery.matches)) {
      setText(title, expanded ? 'Add Your Rating' : 'Ratings & Reviews');
    }

    if (expanded) {
      widget.setAttribute('role', 'dialog');
      widget.setAttribute('aria-modal', 'true');
      widget.setAttribute('aria-label', 'Add your rating');
      widget.scrollTop = 0;
    } else {
      widget.removeAttribute('role');
      widget.removeAttribute('aria-modal');
      widget.removeAttribute('aria-label');
    }
  }

  function buildControls(widget) {
    var header = widget.querySelector('.jdgm-rev-widg__header');
    var title = widget.querySelector('.jdgm-rev-widg__title');
    if (!header || !title) {
      return null;
    }

    if (!widget.dataset.mrjewelsOriginalTitle) {
      widget.dataset.mrjewelsOriginalTitle = title.textContent.trim();
    }
    if (
      !widget.classList.contains('mrjewels-reviews-expanded') &&
      !widget.classList.contains('mrjewels-rating-modal')
    ) {
      setText(title, 'Ratings & Reviews');
    }

    var summary = header.querySelector('.mrjewels-reviews-summary');
    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'mrjewels-reviews-summary';
      summary.innerHTML =
        '<span class="mrjewels-reviews-summary__score">' +
          '<span class="mrjewels-reviews-summary__value"></span>' +
          '<span class="mrjewels-reviews-summary__star" aria-hidden="true">★</span>' +
          '<span class="mrjewels-reviews-summary__divider" aria-hidden="true"></span>' +
          '<span class="mrjewels-reviews-summary__count"></span>' +
        '</span>' +
        '<button class="mrjewels-reviews-toggle" type="button" aria-expanded="false">Show all</button>';
      title.insertAdjacentElement('afterend', summary);

      summary.querySelector('.mrjewels-reviews-toggle').addEventListener('click', function () {
        if (widget.classList.contains('mrjewels-rating-modal')) {
          setRatingModal(widget, false);
        } else {
          setExpanded(widget, !widget.classList.contains('mrjewels-reviews-expanded'));
        }
      });
    }

    var footer = widget.querySelector('.mrjewels-reviews-footer');
    if (!footer) {
      footer = document.createElement('div');
      footer.className = 'mrjewels-reviews-footer';
      footer.innerHTML = '<button class="mrjewels-add-rating" type="button">ADD YOUR RATING</button>';
      widget.appendChild(footer);

      footer.querySelector('.mrjewels-add-rating').addEventListener('click', function () {
        setRatingModal(widget, true);
      });
    }

    return summary;
  }

  function updateWidget(widget) {
    if (!mobileQuery.matches) {
      setRatingModal(widget, false);
      setExpanded(widget, false);
      widget.classList.remove('mrjewels-compact-reviews');
      var desktopTitle = widget.querySelector('.jdgm-rev-widg__title');
      if (desktopTitle && widget.dataset.mrjewelsOriginalTitle) {
        setText(desktopTitle, widget.dataset.mrjewelsOriginalTitle);
      }
      return;
    }

    var summaryControl = buildControls(widget);
    if (!summaryControl) {
      return;
    }

    widget.classList.add('mrjewels-compact-reviews');

    var summary = getSummary(widget);
    if (widget.classList.contains('mrjewels-rating-modal')) {
      setText(widget.querySelector('.jdgm-rev-widg__title'), 'Add Your Rating');
    } else if (widget.classList.contains('mrjewels-reviews-expanded')) {
      setText(
        widget.querySelector('.jdgm-rev-widg__title'),
        'Reviews (' + summary.count + ')'
      );
    }
    var score = summaryControl.querySelector('.mrjewels-reviews-summary__score');
    setText(
      score.querySelector('.mrjewels-reviews-summary__value'),
      summary.average + ' (' + summary.count + ')'
    );
    setText(
      score.querySelector('.mrjewels-reviews-summary__count'),
      summary.count + (summary.count === 1 ? ' Review' : ' Reviews')
    );
    score.setAttribute(
      'aria-label',
      summary.average + ' out of 5, based on ' + summary.count + (summary.count === 1 ? ' review' : ' reviews')
    );

    var reviews = Array.from(widget.querySelectorAll('.jdgm-rev-widg__body .jdgm-rev'));
    reviews.forEach(function (review, index) {
      review.classList.toggle('mrjewels-review--featured', index === 0);
      review.classList.toggle('mrjewels-review--preview', index < 5);
      review.classList.toggle('mrjewels-review--extra', index >= 5);
    });

    var toggle = summaryControl.querySelector('.mrjewels-reviews-toggle');
    toggle.hidden = reviews.length <= 1;
  }

  function initialize() {
    scheduled = false;
    document.querySelectorAll(widgetSelector).forEach(updateWidget);
  }

  function scheduleInitialization() {
    if (scheduled) {
      return;
    }

    scheduled = true;
    window.requestAnimationFrame(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInitialization, { once: true });
  } else {
    scheduleInitialization();
  }

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', scheduleInitialization);
  } else {
    mobileQuery.addListener(scheduleInitialization);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') {
      return;
    }

    var modalWidget = document.querySelector(
      widgetSelector + '.mrjewels-reviews-expanded, ' + widgetSelector + '.mrjewels-rating-modal'
    );
    if (modalWidget) {
      if (modalWidget.classList.contains('mrjewels-rating-modal')) {
        setRatingModal(modalWidget, false);
      } else {
        setExpanded(modalWidget, false);
      }
      var toggle = modalWidget.querySelector('.mrjewels-reviews-toggle');
      if (toggle) {
        toggle.focus();
      }
    }
  });

  new MutationObserver(scheduleInitialization).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();
